/** Human-readable options for HRMS company policy settings (codes stay as stored values). */

export const POLICY_PACK_OPTIONS = [
  {
    value: 'UAE_FEDERAL_33_2021',
    label: 'UAE Federal Labour Law (Decree-Law 33/2021)',
  },
  {
    value: 'INDIA_PRIVATE_SECTOR_BASE',
    label: 'India private sector / school baseline (POGA gratuity + EL/CL/SL)',
  },
] as const;

export const EOSB_FORMULA_OPTIONS = [
  {
    value: 'UAE_FEDERAL_33_2021',
    label: 'UAE gratuity — 21 days/yr (yrs 1–5), 30 days/yr after; basic only; 2-year cap',
  },
  {
    value: 'INDIA_POGA_1972',
    label: 'India Payment of Gratuity Act — (15/26)×wages×completed years; min 5 yrs; ₹20L cap',
  },
] as const;

export const WORK_WEEK_OPTIONS = [
  { value: 'SUN_THU', label: 'Sunday – Thursday (UAE private sector default)' },
  { value: 'MON_FRI', label: 'Monday – Friday' },
  { value: 'MON_SAT', label: 'Monday – Saturday (common India school / office)' },
  { value: 'SAT_WED', label: 'Saturday – Wednesday' },
] as const;

export const COMPLIANCE_JURISDICTION_OPTIONS = [
  { value: 'UAE_MAINLAND', label: 'UAE mainland (Federal Decree-Law 33/2021)' },
  { value: 'UAE_FREEZONE', label: 'UAE free zone (pack TBD)' },
  { value: 'GCC_OTHER', label: 'Other GCC (pack TBD)' },
  { value: 'INDIA_CENTRAL', label: 'India central (POGA + operational leave baseline)' },
] as const;

export const VALUATION_METHOD_OPTIONS = [
  { value: 'STATUTORY_UAE', label: 'STATUTORY_UAE (mirrors UAE gratuity — not IAS 19)' },
  { value: 'STATUTORY_INDIA', label: 'STATUTORY_INDIA (mirrors POGA gratuity — not IAS 19)' },
  { value: 'EXTERNAL_ACTUARIAL', label: 'EXTERNAL_ACTUARIAL (import approved results)' },
] as const;

/** Forgotten mobile check-out — stored on `hrms.punch.forgotten_checkout_policy`. */
export const FORGOTTEN_CHECKOUT_POLICY_OPTIONS = [
  {
    value: 'manual_out_required',
    label: 'Require check-out — employee must punch OUT before the next IN (default)',
  },
  {
    value: 'auto_close_at_shift_end',
    label: 'Auto-close at shift end — system closes open IN after shift end (+ grace)',
  },
  {
    value: 'auto_close_at_midnight',
    label: 'Auto-close at midnight — system closes open IN at end of the local work day',
  },
  {
    value: 'regularization_required',
    label: 'Regularization required — overnight open IN blocks punches until HR corrects attendance',
  },
] as const;

export const OT_EXCESS_OPTIONS = [
  {
    value: 'TOIL',
    label: 'Time off in lieu (TOIL) — bank excess hours as leave',
  },
  {
    value: 'Pay',
    label: 'Pay excess — include overtime above the monthly cap in payroll',
  },
  {
    value: 'Defer',
    label: 'Defer — keep excess for a later period decision',
  },
  {
    value: 'Discard',
    label: 'Discard — ignore hours above the monthly cap',
  },
] as const;

export const HOLIDAY_TYPE_OPTIONS = [
  { value: 'Public', label: 'Public holiday (national / state)' },
  { value: 'Religious', label: 'Religious holiday' },
  { value: 'Floating', label: 'Floating / optional company day' },
  { value: 'Company', label: 'Company-declared holiday' },
] as const;

export const SALARY_HEAD_TYPE_OPTIONS = [
  { value: 'Earning', label: 'Earning (adds to gross / net)' },
  { value: 'Deduction', label: 'Deduction (reduces net pay)' },
] as const;

export const OT_KIND_OPTIONS = [
  {
    value: 'Normal',
    label: 'Normal day OT',
    defaultRate: 1.25,
    help: 'Weekday overtime beyond normal hours (UAE default 125%; India pack seeds 200%)',
  },
  {
    value: 'Friday',
    label: 'Weekly rest-day OT',
    defaultRate: 1.5,
    help: 'Work on the weekly rest day (UAE Friday 150%; India pack seeds 200% as rest day)',
  },
  {
    value: 'Holiday',
    label: 'Public holiday OT',
    defaultRate: 1.5,
    help: 'Work on a public / company holiday',
  },
  {
    value: 'Night',
    label: 'Night differential OT',
    defaultRate: 1.5,
    help: 'OT on a night shift (uses shift is_night when auto-classified)',
  },
] as const;

export function isIndiaHrmsPack(pack?: string | null): boolean {
  return String(pack || '').startsWith('INDIA_');
}
